/* Welaza: carry the emirate chosen in the cart drawer into checkout.
   Saves it as a cart attribute (visible on the order) and prefills
   country + emirate in checkout when the choice is one emirate. */
(() => {
  if (window.__wzCheckoutBound) return;
  window.__wzCheckoutBound = true;

  const PROVINCE = { DU: 'DU', AD: 'AZ' };
  const NAMES = { DU: 'Dubai', SH: 'Sharjah / Ajman', AD: 'Abu Dhabi / Al Ain', NR: 'Fujairah / RAK / UAQ' };
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const chosenZone = () => { try { return localStorage.getItem('wz_zone'); } catch (e) { return null; } };

  document.addEventListener('submit', async (e) => {
    const btn = e.submitter;
    if (!btn || btn.name !== 'checkout') return;
    if (e.defaultPrevented || btn.disabled || btn.classList.contains('wz-min-off')) return;
    const zone = chosenZone();
    if (!zone) return;
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);
    data.delete('checkout');
    data.set('attributes[Delivery zone]', NAMES[zone] || zone);
    try {
      await fetch(`${root()}cart/update.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    } catch (err) { console.error('[wz-checkout]', err); }

    const q = new URLSearchParams();
    q.set('checkout[shipping_address][country]', 'AE');
    if (PROVINCE[zone]) q.set('checkout[shipping_address][province]', PROVINCE[zone]);
    window.location.href = `${root()}checkout?${q.toString()}`;
  });
})();
